export const bookingCandidatesEndpoint = '/shipments/booking-candidates' as const
